import { createProductName } from 'nove8/helpers/createProductName'
import { TimeInterval } from 'root-constants'

export const enum GoogleAnalyticsAction {
  EVENT = 'event',
}

export const enum GoogleAnalyticsEvent {
  PAGE_VIEW = 'page_view',
  ADD_TO_CART = 'add_to_cart',
  PURCHASE = 'purchase',
  FIRST_PAGE_COMPLETED = 'first_page_completed',
}

export const enum GoogleAnalyticsEventCategory {
  TRANSITION = 'transition',
}

class GoogleAnalyticsService {
  logPageView(location: string): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.PAGE_VIEW,
        page_path: `/${location}`,
      })
  }

  logAddingToCart({
    periodName,
    periodQuantity,
    fullPrice,
  }: {
    periodName: TimeInterval
    periodQuantity: number
    fullPrice: number
  }): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.ADD_TO_CART,
        items: [
          {
            id: createProductName({
              periodName,
              periodQuantity,
              price: fullPrice,
            }),
            price: fullPrice,
          },
        ],
      })

    if (window.uetq && import.meta.env.CURRENT_ENV === 'prod') {
      window.uetq = window.uetq || []
      window.uetq.push('event', 'add_to_cart', {})
    }
  }

  logPurchaseCompleted({
    subscriptionId,
    price,
    periodName,
    periodQuantity,
    currency = 'USD',
    predictedLtv,
    email,
  }: {
    subscriptionId: string
    price: number
    periodName: TimeInterval | null
    periodQuantity: number | null
    currency?: string
    predictedLtv?: number
    email?: string
  }): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.PURCHASE,
        transaction_id: subscriptionId,
        value: predictedLtv ?? price,
        currency,
        ...(email && { email }),
        items: [
          {
            id: createProductName({ periodName, periodQuantity, price }),
            price,
          },
        ],
      })
  }

  logFirstPageCompleted(): void {
    window.dataLayer &&
      window.dataLayer.push({
        event: GoogleAnalyticsEvent.FIRST_PAGE_COMPLETED,
        event_category: GoogleAnalyticsEventCategory.TRANSITION,
      })
  }
}

export const googleAnalyticsLogger = new GoogleAnalyticsService()
